/* eslint-disable linebreak-style */
document.addEventListener("DOMContentLoaded", () => {
  const burgerBtn = document.querySelector(".header__burger");
  const burgerIcon = document.querySelector(".header__burger-btn");
  const menuMobile = document.querySelector(".menu__mob-opened");
  const menuLinkMobile = document.querySelectorAll(".menu__link-sub");
  const subMenusMobile = document.querySelectorAll(".menu__sub");
  const openSearch = document.querySelector(".header-search__icon");
  const searchInput = document.querySelector(".header-search__input");
  const closeSearch = document.querySelectorAll(".close-search");
  const searchButton = document.querySelectorAll(".btn-search");
  const headerInput = document.querySelectorAll(".header-input");
  const langBtn = document.querySelector(".lang-button");
  const menuItems = document.querySelectorAll(".header__link");
  const langBlock = document.querySelector(".lang-button__dropdown");
  const dropdownLinks = document.querySelectorAll(".header__link-event");
  const dropdownMenus = document.querySelectorAll(".dropdown-menu");
  const mediaQuery = window.matchMedia("(max-width: 600px)");

  langBtn.addEventListener("click", () => {
      langBlock.style.top =
        langBlock.style.top === "-200px" ? "28px" : "-200px";
    langBtn.classList.toggle("lang-button_open");

    document.addEventListener("click", (e) => {
      if (e.target != langBlock && e.target != langBtn) {
        langBlock.style.top = "-200px";
        langBtn.classList.remove("lang-button_open");
      }
    });
  });

  burgerBtn.addEventListener("click", () => {
    document.body.classList.toggle('no-scroll');
    menuMobile.classList.toggle("menu-open");
    burgerIcon.classList.toggle("header__burger-btn_close");
  });

  menuLinkMobile.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      deleteActive(menuLinkMobile, link, "menu__link-sub_active");
      link.classList.toggle("menu__link-sub_active");
      let dropdownMenu = link.parentElement.querySelector(".menu__sub");
      subMenusMobile.forEach((el) => {
        if (el.classList.contains("menu__sub_open") && el != dropdownMenu) {
          el.classList.remove("menu__sub_open");
        }

        dropdownMenu.classList.toggle("menu__sub_open");

        document.addEventListener("click", (e) => {
          if (
            e.target != link &&
            link.classList.contains("menu__link-sub_active")
          ) {
            dropdownMenu.classList.remove("menu__sub_open");
            link.classList.remove("menu__link-sub_active");
          }
        });
      });
    });
  });

  if (closeSearch !== null && openSearch !== null) {
    openSearch.addEventListener("click", () => {
      searchInput.style.top = "0";
      // searchButton.style.top = "2px";
    });

    closeSearch.forEach( el => {
      el.addEventListener("click", () => {
        searchInput.style.top = "-100px";
        // searchButton.style.top = "-100px";
        headerInput.forEach(ipt => ipt.value = '');
      });
    })
  }

  if (dropdownLinks) {
    dropdownLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        deleteActive(dropdownLinks, link, "header__link-event_active");
        deleteActive(menuItems, link.parentElement, "header__link_active");
        link.classList.toggle("header__link-event_active");
        if (link.parentElement.classList.contains("header__link_active")) {
          link.parentElement.classList.remove("header__link_active");
        } else {
          link.parentElement.classList.add("header__link_active");
        }

        let dropdown = link.parentElement.querySelector(".dropdown-menu");
        dropdownMenus.forEach((el) => {
          if (el.classList.contains("dropdown-menu_active") && el != dropdown) {
            el.classList.remove("dropdown-menu_active");
          }
        });
        dropdown.classList.toggle("dropdown-menu_active");

        document.addEventListener("click", (e) => {
          if (e.target != dropdown && e.target != link) {
            dropdown.classList.remove("dropdown-menu_active");
            link.classList.remove("header__link-event_active");
            link.parentElement.classList.remove("header__link_active");
          }
        });
      });
    });
  }
});

function deleteActive(nodes, link, className) {
  nodes.forEach((node) => {
    if (node != link) {
      node.classList.remove(className);
    }
  });
}
